// Avisa quando sai uma versão nova do sistema (novo "npm run build"), sem precisar pedir F5 a ninguém.
// A cada minuto (e quando a aba volta a ficar visível) compara o arquivo principal desta tela
// com o do build atual no servidor (asset-manifest.json).
//  - Aba em segundo plano: recarrega sozinha (ninguém está mexendo nela).
//  - Aba em uso: mostra uma faixa "Nova versão disponível" com o botão Atualizar,
//    para não perder um cadastro que esteja sendo preenchido.

const INTERVALO_MS = 60 * 1000;

const scriptAtual = () => {
    const s = document.querySelector('script[src*="/static/js/main."]');
    return s ? new URL(s.src, window.location.href).pathname : null;
};

const scriptNoServidor = async () => {
    const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const m = await r.json();
    const main = (m.files && m.files['main.js']) || (m.entrypoints || []).find((e) => /main\..*\.js$/.test(e));
    return main ? new URL(main, window.location.origin).pathname : null;
};

let faixaMostrada = false;
const mostrarFaixa = () => {
    if (faixaMostrada) return;
    faixaMostrada = true;
    const faixa = document.createElement('div');
    faixa.setAttribute('role', 'status');
    faixa.style.cssText = 'position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:99999;'
        + 'background:#312e81;color:#fff;padding:10px 14px;border-radius:8px;box-shadow:0 4px 16px rgba(0,0,0,.25);'
        + 'font:14px system-ui,sans-serif;display:flex;gap:12px;align-items:center;max-width:calc(100% - 32px);';
    faixa.innerHTML = '<span>Nova versão do sistema disponível.</span>';
    const botao = document.createElement('button');
    botao.type = 'button';
    botao.textContent = 'Atualizar';
    botao.style.cssText = 'background:#fff;color:#312e81;border:0;border-radius:6px;padding:6px 12px;font-weight:600;cursor:pointer;';
    botao.onclick = () => window.location.reload();
    faixa.appendChild(botao);
    document.body.appendChild(faixa);
};

let verificando = false;
const verificar = async () => {
    const atual = scriptAtual();
    if (!atual || verificando) return; // em desenvolvimento (npm start) não há main.<hash>.js
    verificando = true;
    try {
        const novo = await scriptNoServidor();
        if (novo && novo !== atual) {
            if (document.hidden) window.location.reload();
            else mostrarFaixa();
        }
    } catch (e) {
        // servidor fora do ar ou no meio de um build: tenta de novo depois
    } finally {
        verificando = false;
    }
};

export const iniciarAvisoDeAtualizacao = () => {
    if (!scriptAtual()) return;
    setInterval(verificar, INTERVALO_MS);
    document.addEventListener('visibilitychange', verificar);
};
